export const honeypotField = 'first_school';
